import { render, staticRenderFns } from "./NewMessageReceptor.vue?vue&type=template&id=5dcf808d&scoped=true&"
import script from "./NewMessageReceptor.vue?vue&type=script&lang=js&"
export * from "./NewMessageReceptor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcf808d",
  null
  
)

export default component.exports